/**
 * Class to provide the global constants
 */

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Const {
    // eslint-disable-next-line no-useless-escape
    static readonly EmailValidatorPattern = /^[\d\w._\-+]+@([\d\w._\-]+.)+[\w]+$/i
}
